import styled from "@emotion/styled";
import { mq } from "@utils/media-query/mediaQuery";
import { useIntl } from "react-intl";
import { LOCAL_STORAGE_LANGUAGE } from "@utils/api-requests/static-data";
import { useCallback, useMemo } from "react";
import { Link } from "react-router-dom";

export const SectionWrapper = styled.div(() => ({
  background: "#F3F3F3",
  width: "100%",
  padding: "2rem",

  [mq("tablet")]: {
    padding: "3rem",
  },

  [mq("desktop")]: {
    padding: "5rem",
  },
}));

export const SectionTitle = styled.h2(() => ({
  marginBottom: "1rem",
  fontSize: "2rem",
  fontWeight: 100,

  [mq("tablet")]: {
    fontSize: "2.4rem",
  },

  [mq("desktop")]: {
    fontSize: "3.2rem",
  },
}));

export const EventGridBox = styled.div(({ column = "2", gap }) => ({
  width: "100%",
  display: "grid",
  gridTemplateColumns: "repeat(1, 1fr)",
  gap: gap ? gap : "1.5rem",

  [mq("tablet")]: {
    gridTemplateColumns: `repeat(${column}, minmax(200px, 1fr))`,
    gap: gap ? gap : "1.5rem",
  },

  [mq("desktop")]: {
    gridTemplateColumns: `repeat(${column}, 1fr)`,
    gap: gap ? gap : "2.5rem",
  },
}));

const ViewMoreButtonStyling = styled(Link)(({ theme, primary }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: `2px solid ${theme.color.event_theme}`,
  fontWeight: 700,
  textDecoration: "none",
  cursor: "pointer",
  maxWidth: "12rem",
  height: "3rem",
  fontSize: "1rem",
  background: primary ? theme.color.event_theme : theme.color.white,
  color: primary ? theme.color.white : theme.color.event_theme,
  flex: 1,

  [mq("desktop")]: {
    width: "16rem",
    maxWidth: "16rem",
    height: "4rem",
    fontSize: "1.6rem",
  },
}));

export const RGUEST_URL =
  "https://book.inspireresorts.com/onecart/wbe/offers/20044/InspireEntertainmentResort";
export const EventButton = ({
  link,
  buttonName,
  primary,
  customLink,
  rguestLink,
  outerLink,
}) => {
  const intl = useIntl();
  const intlFormat = (id) => {
    return intl.formatMessage({
      id: id,
    });
  };
  const lang = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  let agilysysLang;

  switch (lang) {
    case "zh-hans":
      agilysysLang = "ZH-CN";
      break;
    case "zh-hant":
      agilysysLang = "ZH-TW";
      break;
    default:
      agilysysLang = lang?.toUpperCase();
      break;
  }

  const linkUrl = useMemo(() => {
    if (customLink) {
      return customLink;
    }

    if (rguestLink) {
      return `${RGUEST_URL}?offerCode=${rguestLink}&langCode=${agilysysLang}`;
    }

    if (link) {
      return `/${lang}${link}`;
    }
  }, [agilysysLang, customLink, lang, link, rguestLink]);

  const linkToOuterSite = useCallback(() => {
    if (outerLink) {
      window.open(linkUrl, "_blank", "noopener, noreferrer");

      return;
    }

    if (rguestLink || customLink) {
      window.location.href = linkUrl;
    }
  }, [customLink, linkUrl, outerLink, rguestLink]);

  return (
    <ViewMoreButtonStyling
      to={link ? linkUrl : ""}
      primary={primary}
      onClick={linkToOuterSite}
    >
      {buttonName ? buttonName : intlFormat("lang-view-more")}
    </ViewMoreButtonStyling>
  );
};
